module.exports = __webpack_public_path__ + "static/media/01B.f4954069.png";